import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// material-ui
import { ButtonBase, Stack } from "@mui/material";

// project imports
import config from "config";
import { MENU_OPEN, MENU_SELECT } from "store/actions";

// ==============================|| MAIN LOGO ||============================== //

const CompanyLogo = ({ src }) => {
  // const theme = useTheme();
  // const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();

  const loadDispatch = () => {};
  return (
    <ButtonBase
      disableRipple
      onClick={() => {
        dispatch({
          type: MENU_OPEN,
          id: defaultId,
        });
        dispatch({
          type: MENU_SELECT,
          payload: {
            menuItem: "jobPositions",
          },
        });
      }}
      component={Link}
      to={config.defaultPath}
    >
      <Stack alignItems="center" justifyContent="center" spacing={1}>
        {/* <Typography color={theme.palette.primary.main} gutterBottom variant={matchDownSM ? 'h3' : 'h2'}>
              Hiredrate
            </Typography> */}
        <img
          src={`data:image/jpeg;base64,${src}`}
          alt="Berry"
          width="150"
          height="50"
          style={{ objectFit: "contain" }}
        />
      </Stack>
    </ButtonBase>
  );
};

export default CompanyLogo;
